import React, { Component } from 'react';
import { euro } from './Variables';
import { Link } from 'react-router-dom';
import "./homepage.css";
import { InfoBlock } from './InfoBlock';
import { dateSuffix, dateAndMonth } from '../Functions/Generic';
import { MiniStatement } from './MiniStatement';
import { Website } from '../BaseUrl';

export class Home extends Component {
    displayName = Home.name

    constructor(props) {
        super(props);

        this.props.changeLogo("default", true);
    }

    render() {
        var isEmpty = Object.keys(this.props.summary).length === 0 && this.props.summary.constructor === Object;
        return (
            <div className="home-page-container" style={{ width: "100%" }}>
                <div className="desktop-only">
                    <div className="large-title">
                        <h2 className="text-center"> Welcome back, {this.props.name.firstname} </h2>
                    </div>
                </div>
                <div className="container">
                    <AgreementDetails {...this.props}/>
                    <div className="mobile-only">
                        <div style={{margin: "20px 0"}} className="text-center">
                            <Link to={"/make-payment"} className="btn btn-lg btn-primary">
                                Make a payment
                            </Link>
                        </div>
                        <div className="page-container">
                            <ButtonLinks />
                        </div>
                        <InfoBlock title={"Lenders Signature"} >
                            <div>
                                <div className="signature">Daniel Hawkins</div>
                                <div>Daniel Hawkins</div>
                                <div><small>On behalf of Amigo Ireland</small></div>
                            </div>
                        </InfoBlock>
                        <div style={{ margin: "20px 0" }} >
                            <InfoBlock color={"#408080"} title={"Loan Information"} > 
                                <div>
                                    The loan was for  {euro}{!isEmpty && this.props.summary.payoutAmount.toFixed(2)} over a
                                    term of {this.props.summary.term} months. Your guarantor is {this.props.summary.guarantorName}.
                                </div>
                            </InfoBlock>
                        </div>
                    </div>
                    <div className="desktop-only">
                        <div className="homepage-container">
                            <MiniStatement {...this.props}/>
                            <div className="key-info">
                                <h3>Key Information</h3>
                                <InfoBlock title={"Lenders Signature"} >
                                    <div>
                                        <div className="signature">Daniel Hawkins</div>
                                        <div>Daniel Hawkins</div>
                                        <div><small>On behalf of Amigo Ireland</small></div>
                                    </div>
                                </InfoBlock>
                                <div style={{ margin: "20px 0" }} >
                                    <InfoBlock color={"#408080"} title={"Loan Information"} >
                                        <div>
                                            The loan was for {euro}{!isEmpty && this.props.summary.payoutAmount.toFixed(2)} over a
                                            term of {this.props.summary.term} months. {
                                                this.props.isBorrower ? <span>Your guarantor is {this.props.summary.guarantorName}</span> :
                                                    <span>The borrower is {this.props.summary.borrowerName}</span>
                                            }.
                                        </div>
                                    </InfoBlock>
                                </div>

                                <div style={{ margin: "20px 0" }} className="text-center">
                                    <Link to={"/make-payment"} className="btn btn-lg btn-primary">
                                        Make a payment
                                    </Link>
                                </div>
                            </div>
                            <div className="helpful-links">
                                <h3>Helpful Links</h3>
                                <div>
                                    <Link to={"/details"} style={{ color: "#004561", display: "block", margin: "8px 0" }}>
                                        <i style={{ marginRight: "15px"}} className="fas fa-angle-right"></i> <span>Change your details</span>
                                    </Link>
                                    <Link to={"/repayments"} style={{ color: "#004561", display: "block", margin: "8px 0"}}>
                                        <i style={{ marginRight: "15px"}} className="fas fa-angle-right"></i> <span>Your repayment details</span>
                                    </Link>
                                    <Link to={"/statements"} style={{ color: "#004561", display: "block", margin: "8px 0"}}>
                                        <i style={{ marginRight: "15px"}} className="fas fa-angle-right"></i> <span>View your statement</span>
                                    </Link>
                                    <Link to={"/change-password"} style={{ color: "#004561", display: "block", margin: "8px 0"}}>
                                        <i style={{ marginRight: "15px"}} className="fas fa-angle-right"></i> <span>Change your password</span>
                                    </Link>
                                    <a href={`${Website}/faq`} style={{ color: "#004561", display: "block", margin: "8px 0" }}>
                                        <i style={{ marginRight: "15px" }} className="fas fa-angle-right"></i> <span>FAQ</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
    );
  }
}

const AgreementDetails = (props) => {
    var isEmpty = Object.keys(props.summary).length === 0 && props.summary.constructor === Object;
    return (
        <div className="agreement-details-container">
            <div className="agreement-detail">
                <label className="title">Agreement Number(s)</label>
                <p className="value agreement-numbers">                    
                    <span>{props.summary.loanReferenceNumber}</span>                               
                </p>
            </div>
            <div className="agreement-detail">
                <label className="title">Balance To Settle</label>
                <p className="value">{euro}{!isEmpty && props.summary.currentBalance.toFixed(2)}</p>
            </div>
            <div className="agreement-detail">
                <label className="title">Payment Amount</label>
                <p className="value">{euro}{!isEmpty && props.summary.rmiAmount.toFixed(2)}</p>
            </div>
            <div className="agreement-detail">
                <label className="title">Next Payment Date</label>
                <p className="value">{dateAndMonth(props.summary.nextRmiPaymentDate)}</p>
            </div>
        </div>
    );
}

const ButtonLinks = () => {
    return (        
        <div className="LargeButtonContainer">
            <Link className="LargeButton" to={"/details"}>
                <div className="inner-button">
                    <div><span style={{fontSize: "35px", marginBottom: "5px"}} className="far fa-user"></span></div>
                    <div>Your Details</div>
                </div>
            </Link>

            <Link className="LargeButton" to={"/agreements"}>
                <div className="inner-button">
                    <div><span style={{ fontSize: "35px", marginBottom: "5px" }} className="far fa-user"></span></div>
                    <div>Your Agreements</div>
                </div>
            </Link>

            <Link className="LargeButton" to={"/statements"}>
                <div className="inner-button">
                    <div><span style={{ fontSize: "35px", marginBottom: "5px" }} className="fas fa-receipt"></span></div>
                    <div>Statements</div>
                </div>
            </Link>

            <Link className="LargeButton" to={"/repayments"}>
                <div className="inner-button">
                    <div><span style={{ fontSize: "35px", marginBottom: "5px" }} className="far fa-credit-card"></span></div>
                    <div>Repayments</div>
                </div>
            </Link>
        </div>        
    );
}


// WEBPACK FOOTER //
// ./src/components/Home.js